import { createMachine } from 'xstate';

import shared from 'common/bento/shared';
import { BentoModuleDoneStatus } from 'common/bento/types/BentoModule';
import { AnyMachineEvent } from 'features/Bento/types/Abstract';

import actions from './actions';
import guards from './guards';
import model, { Context } from './model';
import services from './services';

export enum State {
  INTRODUCTION = 'introduction',
  HUB = 'hub',
  AGREEMENT = 'agreement',
  COMPLIANCE = 'compliance',
  REGISTRATION_DATE = 'registration-date',
  SUCCESS = 'success',
  DONE = 'done',
}

const machine = createMachine<Context, AnyMachineEvent>(
  {
    context: model.initialContext,

    id: 'ep-agreement-wall',

    initial: State.INTRODUCTION,

    on: {
      '*': {
        actions: shared.actions.unhandled(),
      },
    },

    states: {
      [State.INTRODUCTION]: {
        /**
         * Eject users that shouldn’t be on this flow.
         */
        always: {
          cond: 'shouldNotAskForEpCguAgreement',
          target: State.DONE,
        },
        entry: shared.actions.trackView(),
        on: {
          NEXT: [
            { cond: 'hasMissingInformation', target: State.HUB },
            { target: State.AGREEMENT },
          ],
        },
      },

      [State.HUB]: {
        always: {
          cond: 'hasCompletedAllSteps',
          target: State.SUCCESS,
        },
        entry: shared.actions.trackView(),
        on: {
          AGREEMENT: State.AGREEMENT,
          COMPLIANCE: State.COMPLIANCE,
          REGISTRATION_DATE: State.REGISTRATION_DATE,
        },
      },

      [State.AGREEMENT]: {
        on: {
          NEXT: State.HUB,
          PREV: [
            { cond: 'hasMissingInformation', target: State.HUB },
            { target: State.INTRODUCTION },
          ],
        },
      },

      [State.COMPLIANCE]: {
        entry: shared.actions.trackView(),
        on: {
          NEXT: State.HUB,
          PREV: State.HUB,
        },
      },

      [State.REGISTRATION_DATE]: {
        entry: shared.actions.trackView(),
        on: {
          NEXT: State.HUB,
          PREV: State.HUB,
        },
      },

      [State.SUCCESS]: {
        entry: [
          shared.actions.trackView(),
          'clearStoredSteps',
          'refetchLoggedInRoutesAccess',
        ],
        on: {
          NEXT: State.DONE,
          PREV: State.DONE,
        },
      },

      [State.DONE]: {
        data: {
          status: BentoModuleDoneStatus.DONE,
        },
        type: 'final',
      },
    },
  },

  {
    actions,
    guards,
    services,
  },
);

export default machine;
